const keys = {
  ALERTA_VENCIMENTO_DATA_FATURAMENTO_COMPRA: {
    key: 'ALERTA_VENCIMENTO_DATA_FATURAMENTO_COMPRA',
    description: 'Enviar notificação de alerta ao fornecedor sobre o vencimento do prazo de faturamento da compra.',
    defaultEmailEnabledValue: true,
    defaultWhatsappEnabledValue: false,
  },
};

const values = Object.keys(keys)
  .map(key => keys[key]);

export default {
  keys,
  values,
};
